import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import 'react-phone-input-2/lib/style.css'
import PhoneInput from 'react-phone-input-2'

// antd
import {
    Avatar,
    Card,
    Col,
    DatePicker,
    Empty,
    Form,
    Image,
    Input,
    Radio,
    Row,
    Select,
    Upload,
    message,
} from 'antd'

// assets
import { UploadImageIcon } from '../../../../../assets/icons'

// store
import { loginState } from '../../../../login/login.slice'
import {
    changeModel,
    masterDataAddDropDown,
    masterDataDropDownList,
    profileState,
} from '../../../../profile/profile.slice'
import { setProfileImageFile } from '../../store/applicationDraft.slice'

// components
import ApiSelect from '../../../../../components/api-select/api-select'
import DropDownMultiple from '../../../../../components/dropDownMultiple'

// constants
import { MASTER_DATA_FIELD } from '../../../../../constants/masterData'
import {
    normalizePhoneNumber,
    PHONE_COUNTRIES,
} from '../../../../../constants/phone-countries'

// helpers
import useGooglePlace from '../../../../../helpers/googlePlacesFunction'

import dayjs from 'dayjs'

const OverviewSection = ({
    form,
    fileURL,
    name = 'Candidate User',
    currentData,
}) => {
    const dispatch = useDispatch()
    const { formButtonType, modelType, masterDataDropDown, isNext } =
        useSelector(profileState)
    const { userProfile } = useSelector(loginState)

    const [previewImage, setPreviewImage] = useState(
        currentData?.profilePicture || ''
    )
    const [searchValue, setSearchValue] = useState('')
    const [page, setPage] = useState(0)
    const [loadingStatus, setLoadingStatus] = useState('loading')
    const [inputValue, setInputValue] = useState('')
    const [places, setPlaces] = useState([])

    const initialState = {
        phoneValid: false,
        phoneNumber: {
            default: null,
            phoneNo: null,
            code: null,
            flag: null,
        },
    }

    const [state, setState] = useState(initialState)

    useGooglePlace(inputValue, setPlaces)

    const resetPage = () => setPage(1)

    const fetchOptions = async (search = '', pageNumber = 1, model) => {
        setLoadingStatus('loading')
        setSearchValue(search)
        try {
            dispatch(changeModel(model))
            const result = await dispatch(
                masterDataDropDownList({ search, id: model, skip: pageNumber })
            ).unwrap()
            const newData = Array.isArray(result?.data) ? result.data : []
            setPage(pageNumber + 1)
            setLoadingStatus(newData.length === 0 ? 'noData' : 'loaded')
        } catch (error) {
            console.error('Dropdown fetch failed', error)
            setLoadingStatus('noData')
        }
    }

    useEffect(() => {
        if (!currentData || !form) return

        // Only proceed if we have both country flag and phone
        const countryFlag = currentData?.primaryContactNumberCountryFlag
        const countryCode = currentData?.primaryContactNumberCountryCode
        const rawPhone = currentData?.primaryContactNumber

        if (!countryFlag || !countryCode || !rawPhone) {
            setState((prevState) => ({
                ...prevState,
                phoneValid: false,
            }))
            return
        }

        const correspondingCountry = PHONE_COUNTRIES.find(
            (c) => c.iso2 === countryFlag
        )

        const dialCode = countryCode.replace('+', '') || ''

        let numberWithoutCode = rawPhone.startsWith(dialCode)
            ? rawPhone.slice(dialCode.length)
            : rawPhone

        let numberNew = normalizePhoneNumber(
            `${countryCode}${numberWithoutCode}`,
            {
                iso2: countryFlag.toUpperCase(),
                dialCode: dialCode,
            }
        )

        if (correspondingCountry?.validation?.test(numberNew)) {
            setState((prevState) => ({
                ...prevState,
                phoneValid: true,
            }))
        } else {
            setState((prevState) => ({
                ...prevState,
                phoneValid: false,
            }))
        }
    }, [currentData, form])

    async function addMasterData() {
        const result = await dispatch(
            masterDataAddDropDown({
                addData: {
                    type: 'manual',
                    data: {
                        name: searchValue,
                        logo:
                            modelType === 'tools'
                                ? 'https://pms-bucket123.s3.amazonaws.com/Layer_1_1689237094.svg'
                                : modelType === 'institute'
                                ? 'https://pms-bucket123.s3.amazonaws.com/Group 35301_1689226177.svg'
                                : '',
                        createdBy: userProfile?._id,
                    },
                },
                model: modelType,
            })
        )
        const data = result?.payload?.data
        if (data?.success) {
            dispatch(
                masterDataDropDownList({ search: searchValue, id: modelType })
            )
        } else {
            message.error(
                data?.message || 'Something went wrong, try again later.'
            )
        }
    }

    return (
        <>
            <Row
                align="middle"
                justify="center"
                gutter={16}
                style={{ marginBottom: '10px' }}
            >
                <Col xs={24} sm={24} md={12} lg={12}>
                    <Card style={{ display: 'flex', justifyContent: 'center' }}>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                            className="candidate_upload_profile"
                        >
                            <Upload
                                listType="picture-circle"
                                className="avatar-uploader-candidate-details"
                                showUploadList={false}
                                accept=".png,.jpg,.jpeg"
                                beforeUpload={(file) => {
                                    const isImage =
                                        file.type.startsWith('image/')
                                    if (isImage) {
                                        const url = URL.createObjectURL(file)
                                        setPreviewImage(url)
                                        dispatch(setProfileImageFile(file))
                                    }
                                    return false
                                }}
                            >
                                {previewImage ? (
                                    <Image
                                        src={previewImage}
                                        preview={false}
                                        style={{
                                            height: 128,
                                            width: 128,
                                            borderRadius: '50%',
                                        }}
                                    />
                                ) : fileURL?.length > 0 ? (
                                    <Image
                                        src={fileURL[0]}
                                        preview={false}
                                        style={{
                                            height: 128,
                                            width: 128,
                                            borderRadius: '50%',
                                        }}
                                    />
                                ) : (
                                    <Avatar size={128}>
                                        {currentData?.fullName
                                            ? currentData?.fullName
                                                  .trim()[0]
                                                  .toUpperCase()
                                            : name
                                                  ?.trim()?.[0]
                                                  ?.toUpperCase() || ''}
                                    </Avatar>
                                )}

                                <div className="hoverLayer">
                                    <div className="hoverShow">
                                        <UploadImageIcon />
                                        <div
                                            style={{
                                                marginTop: 8,
                                                color: '#fff',
                                            }}
                                        >
                                            Update Profile
                                        </div>
                                    </div>
                                </div>
                            </Upload>
                        </div>
                    </Card>
                </Col>

                <Col span={12}>
                    <Form.Item
                        label="Name"
                        name="name"
                        style={{ marginTop: 10 }}
                        rules={[
                            { required: true, message: 'Name is required' },
                        ]}
                    >
                        <Input placeholder="Full Name" size="large" />
                    </Form.Item>

                    <Form.Item
                        label="Email"
                        name="email"
                        style={{ marginTop: 10 }}
                        rules={[
                            { required: true, message: 'Email is required' },
                            { type: 'email', message: 'Enter a valid email' },
                        ]}
                    >
                        <Input placeholder="Email" size="large" />
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item
                label="Phone Number"
                name="phone"
                rules={[
                    {
                        validator: async () => {
                            const phone = form.getFieldValue('phone') || ''
                            const countryCode =
                                form.getFieldValue(
                                    'primaryContactNumberCountryCode'
                                ) || ''

                            const dialCode = countryCode.replace('+', '')

                            let numberWithoutCode = phone.startsWith(dialCode)
                                ? phone.slice(dialCode.length)
                                : phone

                            if (
                                !state?.phoneValid &&
                                numberWithoutCode.length > 0
                            ) {
                                return Promise.reject(
                                    new Error(
                                        'Please Enter a valid Phone Number'
                                    )
                                )
                            }

                            if (numberWithoutCode.length === 0) {
                                return Promise.reject(
                                    new Error('Please Enter Phone Number')
                                )
                            }

                            return Promise.resolve()
                        },
                    },
                ]}
            >
                {/* <PhoneInput
                    inputStyle={{ width: '100%' }}
                    specialLabel=""
                    country="in"
                    onlyCountries={['in']}
                    disableDropdown
                    countryCodeEditable={false}
                /> */}
                <PhoneInput
                    inputStyle={{ width: '100%' }}
                    specialLabel=""
                    onlyCountries={[]}
                    country={'in'}
                    enableSearch={true}
                    countryCodeEditable={true}
                    value={form.getFieldValue('phone')}
                    onChange={(number, country) => {
                        form.setFieldsValue({
                            primaryContactNumberCountryCode: `+${country.dialCode}`,
                            primaryContactNumberCountryFlag:
                                country.countryCode.toUpperCase(),
                        })

                        const correspondingCountry = PHONE_COUNTRIES.find(
                            (c) => c.iso2 === country.countryCode?.toUpperCase()
                        )

                        let numberNew = normalizePhoneNumber(`+${number}`, {
                            iso2: country.countryCode?.toUpperCase(),
                            dialCode: country.dialCode,
                        })

                        if (correspondingCountry?.validation.test(numberNew)) {
                            setState((prevState) => ({
                                ...prevState,
                                phoneValid: true,
                            }))
                        } else {
                            setState((prevState) => ({
                                ...prevState,
                                phoneValid: false,
                            }))
                        }
                    }}
                />
            </Form.Item>
            <Form.Item name="primaryContactNumberCountryCode" hidden>
                <Input type="hidden" />
            </Form.Item>

            <Form.Item name="primaryContactNumberCountryFlag" hidden>
                <Input type="hidden" />
            </Form.Item>

            <Form.Item
                label="Address"
                name="address"
                style={{ marginTop: 10 }}
                rules={[{ required: true, message: 'Address is required' }]}
            >
                <Select
                    placeholder="Search a Location"
                    allowClear={false}
                    notFoundContent={
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description="No Locations Searched"
                        ></Empty>
                    }
                    onSearch={(value) => {
                        setInputValue(value)
                    }}
                    showSearch
                    options={places}
                    getPopupContainer={(trigger) => trigger.parentNode}
                />
            </Form.Item>

            <Row gutter={16} style={{ marginTop: 10 }}>
                <Col span={12}>
                    <Form.Item
                        label="Country"
                        name="country"
                        rules={[
                            { required: true, message: 'Country is required' },
                        ]}
                    >
                        <Input placeholder="Country" size="large" />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="State"
                        name="state"
                        rules={[
                            { required: true, message: 'State is required' },
                        ]}
                    >
                        <Input placeholder="State" size="large" />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={16} style={{ marginTop: 10 }}>
                <Col span={12}>
                    <Form.Item
                        label="City"
                        name="city"
                        rules={[
                            { required: true, message: 'City is required' },
                        ]}
                    >
                        <Input placeholder="City" size="large" />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="Birth Date"
                        name="birthDate"
                        rules={[
                            {
                                required: true,
                                message: 'Birth Date is required',
                            },
                        ]}
                    >
                        <DatePicker
                            style={{ width: '100%' }}
                            placeholder="Date of Birth"
                            size="large"
                            disabledDate={(current) =>
                                current && current > dayjs().endOf('day')
                            }
                        />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={16} style={{ marginTop: 10 }}>
                <Col span={12}>
                    <Form.Item
                        label="Total Experience"
                        name="totalExperience"
                        rules={[
                            {
                                required: true,
                                message: 'Total Experience is required',
                            },
                        ]}
                    >
                        <Input
                            placeholder="Total Experience"
                            size="large"
                            type="text"
                            inputMode="decimal"
                            onKeyPress={(e) => {
                                const key = e.key
                                const value = e.currentTarget.value
                                const isDigit = /[0-9]/.test(key)
                                const isDot = key === '.'
                                const alreadyHasDot = value.includes('.')
                                if (!isDigit && !(isDot && !alreadyHasDot))
                                    e.preventDefault()
                            }}
                        />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <ApiSelect
                        label="Designation"
                        name={MASTER_DATA_FIELD.designation}
                        rules={
                            formButtonType !== 'draftButtonLoading'
                                ? [
                                      {
                                          required: true,
                                          message:
                                              'Please Select Field of designation',
                                      },
                                  ]
                                : []
                        }
                        placeholder="Designation"
                        onClick={() => {
                            resetPage()
                            fetchOptions('', 0, MASTER_DATA_FIELD.designation)
                        }}
                        onSearch={(value) => {
                            resetPage()
                            fetchOptions(
                                value,
                                0,
                                MASTER_DATA_FIELD.designation
                            )
                        }}
                        onScrollBottom={() => {
                            fetchOptions(
                                searchValue,
                                page,
                                MASTER_DATA_FIELD.designation
                            )
                        }}
                        dropdownRender={(menu, handleScroll) => (
                            <DropDownMultiple
                                handleScroll={handleScroll}
                                menu={menu}
                                searchValue={searchValue}
                                name={MASTER_DATA_FIELD.designation}
                                addMasterData={addMasterData}
                            />
                        )}
                        options={masterDataDropDown?.designation}
                        dropdownStatus={loadingStatus}
                        isNext={isNext}
                    />
                </Col>
            </Row>

            <Row gutter={16} style={{ marginTop: 10 }}>
                <Col span={12}>
                    <Form.Item
                        label="Marital Status"
                        name="maritalStatus"
                        rules={[
                            {
                                required: true,
                                message: 'Marital Status is required',
                            },
                        ]}
                    >
                        <Radio.Group
                            options={[
                                { label: 'Single', value: 'single' },
                                { label: 'Married', value: 'married' },
                            ]}
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="Gender"
                        name="gender"
                        rules={[
                            { required: true, message: 'Gender is required' },
                        ]}
                    >
                        <Radio.Group
                            options={[
                                { label: 'Male', value: 'male' },
                                { label: 'Female', value: 'female' },
                            ]}
                        />
                    </Form.Item>
                </Col>
            </Row>
        </>
    )
}

export default OverviewSection
